import React, { useState, useCallback, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";

import { Grid, Typography, Button } from "@mui/material";

import { getAllUserRoles, updateRoleAndFetch } from "store/slices/roles";

import { CustomTable, Modal as CustomModal } from "components";
import { filterNormilizeRoles } from "utils";

import { useModal } from "hooks/useModal";
import { getGroup, removeUserFromAllGroups } from "store/slices/groups";

const columns = [
  { id: "username", label: "Name", minWidth: 100, align: "left" },
  { id: "email", label: "Email", minWidth: 100, align: "center" },
  {
    id: "button",
    label: "Remove",
    minWidth: 120,
    align: "center"
  }
];

const useStyles = makeStyles({
  root: {
    width: "100%"
  },
  container: {
    maxHeight: 440
  },
  labelRow: {
    backgroundColor: "#0f15ba1a"
  },
  titleContainer: {
    margin: "1rem 0"
  }
});

function Settings() {
  const { getModal, getModalClass, handleOpen, handleClose, open } = useModal();
  const [listForbiddenEdit, setListForbiddenEdit] = useState(null);
  const [mode, setMode] = useState("");
  const dispatch = useDispatch();
  const classes = useStyles();
  const { loading, allUsers } = useSelector((state) => state.rolesSlice);

  const { allGroups } = useSelector((state) => state.groupSlice);

  const [rowsProctor, setRowsProctor] = useState([]);
  const [rowsModal, setRowsModal] = useState([]);

  useEffect(() => {
    dispatch(getAllUserRoles());
    dispatch(getGroup());
  }, [dispatch]);

  const normilizeData = useCallback((arr) => {
    const normilizedArr = arr.map((item) => {
      return { ...item, button: "Removed" };
    });
    return normilizedArr;
  }, []);

  const filteredNormilizedUsers = useCallback(
    (allUsers, exeptions, extraField) => {
      return filterNormilizeRoles(allUsers, exeptions, extraField);
    },
    []
  );

  useEffect(() => {
    if (allUsers["proctor"].length) {
      setRowsProctor(normilizeData(allUsers["proctor"]));
    }
  }, [loading]); // eslint-disable-line

  useEffect(() => {
    if (!open) {
      setListForbiddenEdit(null);
    }
  }, [open]);

  const handleClick = useCallback(
    (idx, _, row) => {
      rowsProctor.forEach((user, index) => {
        const updateRoleData = {
          id: user.id,
          role: "student",
          organizationId: user.organizationId
        };
        if (index === idx) {
          dispatch(removeUserFromAllGroups(user.id)).then(() => {
            dispatch(updateRoleAndFetch(updateRoleData));
          });
        }
      });
    },
    [rowsProctor, dispatch, allGroups] // eslint-disable-line
  );

  const handleOpenModal = useCallback(
    (role) => () => {
      setMode(role);
      if (role === "proctor") {
        setRowsModal(
          filteredNormilizedUsers(allUsers, role, { checkbox: false })
        );
      }

      handleOpen();
    },
    [setMode, setRowsModal, allUsers] // eslint-disable-line
  );

  const handleAdd = useCallback(() => {
    rowsModal.forEach(async (user) => {
      if (user.checkbox) {
        await dispatch(removeUserFromAllGroups(user.id));
        await dispatch(
          updateRoleAndFetch({
            id: user.id,
            role: mode,
            organizationId: user.organizationId
          })
        );
      }
    });

    handleClose();
    setRowsModal([]);
  }, [rowsModal, setRowsModal, dispatch, mode, handleClose]);

  return (
    <Grid
      container
      className={classes.root}
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      {listForbiddenEdit ? (
        <CustomModal
          listForbiddenEdit={listForbiddenEdit}
          handleClose={handleClose}
          open={open}
          className={getModalClass("ADD_ROLES")}
        >
          {(props) => getModal("FORBIDDEN_EDIT", props)}
        </CustomModal>
      ) : (
        <CustomModal
          rowsModal={rowsModal}
          setRowsModal={setRowsModal}
          mode={mode}
          loading={loading}
          handleClose={handleClose}
          handleAdd={handleAdd}
          open={open}
          className={getModalClass("ADD_ROLES")}
        >
          {(props) => getModal("ADD_ROLES", props)}
        </CustomModal>
      )}

      <Grid item container direction="column" md={10} sm={12} lg={8}>
        <Grid
          item
          container
          justifyContent="space-between"
          className={classes.titleContainer}
        >
          <Typography variant="h5">Proctors:</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal("proctor")}
          >
            Add+
          </Button>
        </Grid>

        <CustomTable
          rows={rowsProctor}
          columns={columns}
          handleClickBtn={handleClick}
          className={classes.rootTable}
        />
      </Grid>
    </Grid>
  );
}

export default Settings;
